import {
  SimpleGrid,
  Stack,
  Title,
  Box,
  Center,
  Grid,
  Paper,
  useMantineTheme,
  Skeleton,
} from "@mantine/core";
import StageCard from "./StageCard";
import { StageFullDetails } from "../utils/types";

export default function Stages(props: {
  regularStages: StageFullDetails[];
  adminStages: StageFullDetails[];
}) {
  const theme = useMantineTheme();

  // Function to render stage cards
  const renderStageCards = (stages: StageFullDetails[], isAdmin: boolean) => {
    return stages.map(function (stage: StageFullDetails, i: number) {
      const pathImg = isAdmin
        ? stage.stage.toLowerCase() + "_admin"
        : stage.stage.toLowerCase();

      const stageDetails = {
        name: stage.stage,
        pathImg: "/" + pathImg + ".png",
      };

      const gitDetails = {
        branch: stage.branch,
        commit: stage.commit,
        tag: stage.tag,
        date: stage.updated_at,
      };

      return (
        <StageCard
          stageDetails={stageDetails}
          gitDetails={gitDetails}
          isAdmin={isAdmin}
          key={i}
        />
      );
    });
  };

  return (
    <Grid gutter="xl">
      {/* Admin Column */}
      <Grid.Col span={{ base: 12, md: 6 }}>
        <Paper p="md" radius="md" bg="gray.1" withBorder>
          <Box mb="md">
            <Center>
              <Title order={2} c="gray.8">
                Food Radar Admin
              </Title>
            </Center>
          </Box>
          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
            {props.adminStages.length > 0
              ? renderStageCards(props.adminStages, true)
              : [1, 2, 3, 4].map((i) => (
                  <Skeleton key={i} height={120} radius="md" animate />
                ))}
          </SimpleGrid>
        </Paper>
      </Grid.Col>

      {/* Regular Column */}
      <Grid.Col span={{ base: 12, md: 6 }}>
        <Paper p="md" radius="md" bg="gray.1" withBorder>
          <Box mb="md">
            <Center>
              <Title order={2} c="gray.8">
                Food Radar
              </Title>
            </Center>
          </Box>
          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
            {props.regularStages.length > 0
              ? renderStageCards(props.regularStages, false)
              : [1, 2, 3, 4].map((i) => (
                  <Skeleton key={i} height={120} radius="md" animate />
                ))}
          </SimpleGrid>
        </Paper>
      </Grid.Col>
    </Grid>
  );
}
